import type { JSX } from "preact";

type IconProps = JSX.SVGAttributes<SVGSVGElement>;

export function IcoLogo({ class: className, ...props }: IconProps) {
  return (
    <svg
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <rect width="32" height="32" rx="8" class="fill-slate-800" />
      <polyline
        fill="none"
        stroke="#fff"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        points="4,16 9,16 11,12 14,20 17,8 20,16 23,16 25,14 28,16"
      />
    </svg>
  );
}
